/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserResponse } from './RevisdomAPIViewModelsUserResponse';
import {
    RevisdomAPIViewModelsUserResponseFromJSON,
    RevisdomAPIViewModelsUserResponseFromJSONTyped,
    RevisdomAPIViewModelsUserResponseToJSON,
    RevisdomAPIViewModelsUserResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryCommentResponse
 */
export interface RevisdomAPIViewModelsEntryCommentResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    id?: number;
    /**
     * 
     * @type {RevisdomAPIViewModelsUserResponse}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    user?: RevisdomAPIViewModelsUserResponse;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    versionId?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    parentCommentId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    startFrame?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    endFrame?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    data?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    isResolved?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    isPinned?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    lastPinnedDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    lastPinnedById?: number | null;
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryCommentResponse>}
     * @memberof RevisdomAPIViewModelsEntryCommentResponse
     */
    replies?: Array<RevisdomAPIViewModelsEntryCommentResponse> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryCommentResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryCommentResponse(value: object): value is RevisdomAPIViewModelsEntryCommentResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryCommentResponseFromJSON(json: any): RevisdomAPIViewModelsEntryCommentResponse {
    return RevisdomAPIViewModelsEntryCommentResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryCommentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryCommentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'user': json['user'] == null ? undefined : RevisdomAPIViewModelsUserResponseFromJSON(json['user']),
        'versionId': json['versionId'] == null ? undefined : json['versionId'],
        'parentCommentId': json['parentCommentId'] == null ? undefined : json['parentCommentId'],
        'startFrame': json['startFrame'] == null ? undefined : json['startFrame'],
        'endFrame': json['endFrame'] == null ? undefined : json['endFrame'],
        'text': json['text'] == null ? undefined : json['text'],
        'data': json['data'] == null ? undefined : json['data'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'isResolved': json['isResolved'] == null ? undefined : json['isResolved'],
        'isPinned': json['isPinned'] == null ? undefined : json['isPinned'],
        'lastPinnedDate': json['lastPinnedDate'] == null ? undefined : (new Date(json['lastPinnedDate'])),
        'lastPinnedById': json['lastPinnedById'] == null ? undefined : json['lastPinnedById'],
        'replies': json['replies'] == null ? undefined : ((json['replies'] as Array<any>).map(RevisdomAPIViewModelsEntryCommentResponseFromJSON)),
    };
}

export function RevisdomAPIViewModelsEntryCommentResponseToJSON(json: any): RevisdomAPIViewModelsEntryCommentResponse {
    return RevisdomAPIViewModelsEntryCommentResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryCommentResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryCommentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user': RevisdomAPIViewModelsUserResponseToJSON(value['user']),
        'versionId': value['versionId'],
        'parentCommentId': value['parentCommentId'],
        'startFrame': value['startFrame'],
        'endFrame': value['endFrame'],
        'text': value['text'],
        'data': value['data'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
        'isResolved': value['isResolved'],
        'isPinned': value['isPinned'],
        'lastPinnedDate': value['lastPinnedDate'] == null ? undefined : ((value['lastPinnedDate'] as any).toISOString()),
        'lastPinnedById': value['lastPinnedById'],
        'replies': value['replies'] == null ? undefined : ((value['replies'] as Array<any>).map(RevisdomAPIViewModelsEntryCommentResponseToJSON)),
    };
}

